var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#4CABB0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7206 27.7065C30.7206 23.3036 29.6324 18.2143 25.2462 18.2143C23.8902 19.5368 22.0487 20.3571 20.0063 20.3571C17.9639 20.3571 16.1223 19.5368 14.7663 18.2143C10.3802 18.2143 9.29199 23.3036 9.29199 27.7065C9.29199 30.1507 10.8991 32.1429 12.8578 32.1429H27.1547C29.1134 32.1429 30.7206 30.1507 30.7206 27.7065ZM26.4349 12.8571C26.4349 9.30803 23.5554 6.42857 20.0063 6.42857C16.4572 6.42857 13.5777 9.30803 13.5777 12.8571C13.5777 16.4062 16.4572 19.2857 20.0063 19.2857C23.5554 19.2857 26.4349 16.4062 26.4349 12.8571Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.e0a6c42690baa90e24b8100deb5a3d1c.svg";
export { ForwardRef as ReactComponent };